<template>
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="pause-play-svg"
  >
    <path
      d="M12.25 8.43301L1.75 14.4952C1.41667 14.6876 0.999999 14.4471 0.999999 14.0622L1 1.93782C1 1.55292 1.41667 1.31236 1.75 1.50481L12.25 7.56699C12.5833 7.75944 12.5833 8.24056 12.25 8.43301Z"
      stroke="black"
    />
  </svg>
</template>